'use client';

import { KeyTextField, LinkField } from '@prismicio/client';
import { PrismicNextLink } from '@prismicio/next';

import { ArrowDown } from '@/assets/icons/ArrowDown';
import { screenSizes } from '@/constants';
import { useScreenSize } from '@/hooks';
import styles from './navigationHeading.module.scss';

export const HEADING_LINK_TYPE_WITHOUT_PATH = 'Any';

export interface NavigationHeadingProps {
  link: LinkField;
  heading: KeyTextField;
  isDropDownMenu?: boolean;
  titleStyle?: string;
  iconStyle?: string;
  footerStyles?: string;
}

export const NavigationHeading = (props: NavigationHeadingProps) => {
  const { heading, isDropDownMenu, link, titleStyle, iconStyle, footerStyles } =
    props;
  const size = useScreenSize();

  const headerStyles = `${styles.title_link} ${titleStyle ?? ''} `;
  const noLink = link.link_type === 'Any';

  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if ((size.width < screenSizes.tablet && isDropDownMenu) || noLink) {
      event.preventDefault();
    }
  };
  return (
    <PrismicNextLink
      field={noLink ? null : link}
      className={footerStyles || headerStyles}
      onClick={handleOnClick}
    >
      <span className={styles.title}>{heading}</span>
      {isDropDownMenu && (
        <div className={`${styles.icon} ${iconStyle ?? ''}`}>
          <ArrowDown />
        </div>
      )}
    </PrismicNextLink>
  );
};
